export default __webpack_public_path__ + "static/media/galaxy-gates.66014612.jpg";